module.exports = __webpack_public_path__ + "static/media/reacttraining-code-bg2.nl.3dc54967.png";